import React from "react";
import Digital from "./Digital";
import Common from "./Common";

export default (props) => {
  if (props.event.extra?.digital) return <Digital {...props} />;

  return <Common {...props} />;
};
